<script setup lang="ts">
import { PV } from "@/widgets";
import { type MaybeRef, unref } from "vue";

const props = defineProps<{
    isLoading?: MaybeRef<boolean>;
    isSubmitting?: MaybeRef<boolean>;
}>();
</script>

<template>
    <div class="min-h-full flex flex-col items-stretch relative">
        <div
            v-if="unref(props.isLoading) === true"
            class="w-full h-full absolute top-0 left-0 flex flex-col items-center justify-center gap-4 px-8"
        >
            <PV.ProgressBar class="w-1/2 h-2! rns-loading" mode="indeterminate" />
            <div>Memuat data ...</div>
        </div>
        <slot v-else></slot>
        <div
            v-if="unref(props.isSubmitting) === true"
            class="absolute top-0 left-0 right-0 bottom-0 backdrop-blur-xs w-full flex flex-col items-center justify-center gap-8"
        >
            <PV.ProgressBar class="w-1/2 h-2.5! shadow-xs rns-submitting" mode="indeterminate" />
            <div class="font-semibold text-4xl">Harap tunggu ...</div>
        </div>
    </div>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-loading :deep(.p-progressbar-value) {
    @apply bg-black;
}

.rns-submitting :deep(.p-progressbar-value) {
    @apply bg-slate-800;
}
</style>
